import { render, staticRenderFns } from "./leoCalendar.vue?vue&type=template&id=1f2cba36&scoped=true&"
import script from "./leoCalendar.vue?vue&type=script&lang=js&"
export * from "./leoCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2cba36",
  null
  
)

export default component.exports